module.exports = __webpack_public_path__ + "static/media/truck1000.777ffde4.svg";